import { useMemo } from 'react';

import styled from 'styled-components';

import { DataTable } from 'components/DataTable';

import { productSummaryColumns, DeliveryProductSummaryRow } from '../constants/productSummaryColumns';

// Per-product recap (DataTable version of the order recap), reused for both stock transfers and orders:
// Demandé · Positionné · Soldout online · Préparé · Soldout bundle.
export const ProductSummaryTable = ({ summary }: { summary: DeliveryProductSummaryRow[] }) => {
    const sortedSummary = useMemo(() => [...summary].sort((a, b) => a.fullname.localeCompare(b.fullname)), [summary]);

    if (sortedSummary.length === 0) {
        return null;
    }

    // The DataTable virtualizes inside a bounded scroll container: size it to the content but cap it
    // so a long recap scrolls instead of stretching the page. +44 leaves room for the totals footer row.
    const height = Math.min(548, 110 + sortedSummary.length * 44 + 44);

    return (
        <TableContainer style={{ height }}>
            <DataTable<DeliveryProductSummaryRow>
                columns={productSummaryColumns}
                data={sortedSummary}
                filterMode="client"
                getRowId={(row) => row.productId}
                getRowLink={(row) => `/product/${row.productId}`}
                searchPlaceholder="Nom du produit"
                searchFilterKey="searchValue"
                disableUrlSync
                disableColumnVisibility
                autoFocusSearch={false}
            />
        </TableContainer>
    );
};

const TableContainer = styled.div`
    overflow: hidden;
`;
